import Vue from 'vue'
import { PLAYBACK_API_TIMEOUT_MS } from './timeouts'

export default {
  apiPrefix: '/api/v2/sites',
  /**
   * 카메라의 ONVIF 녹화 목록(재생 가능 구간)을 브릿지에서 조회한다. playback 모달을 열 때 호출된다.
   *
   * CHEKT-1406: 전용 edge_playback read 엔드포인트(PUT)로 보낸다. 브릿지에 보낼 요청(경로·method·
   * 응답 토픽)은 백엔드가 만들므로 body를 보내지 않는다. 대상은 path의 카메라 device_id로만 지정하며,
   * 백엔드가 그 카메라로 브릿지·채널(chNN)·파티션을 도출한다 — 그래서 접근 불가 파티션이면 403이 된다.
   * (이전에는 브릿지 id와 headers.path를 프런트가 지정했고, 채널을 바꿔 다른 파티션 카메라를 볼 수 있었다.)
   *
   * @param {Object} params
   * @param {number|string} params.siteId   - 사이트 아이디
   * @param {number|string} params.deviceId - 카메라 디바이스 아이디 (브릿지가 아님)
   * @returns {Promise} vue-resource 응답 Promise (res.body = 브릿지의 recordings 응답)
   */
  getOnvifRecordingConfigFromProxy: function ({siteId, deviceId}) {
    let timeout = PLAYBACK_API_TIMEOUT_MS / 1000 // 서버 proxy 대기 시간(초). 앱 xhr timeout과 같은 값
    let apiDetailPath = this.apiPrefix + `/${siteId}/devices/${deviceId}/edge_playback?timeout=${timeout}`
    return Vue.http.put(Vue.env.apiPath + apiDetailPath, {}, Vue.auth.getBearerHeader(PLAYBACK_API_TIMEOUT_MS))
  },
  getPlaybackVideoFromProxy: function ({siteId, bridgeId, rtspUrl, startTime, endTime}) {
    let timeout = PLAYBACK_API_TIMEOUT_MS / 1000 // 서버 proxy 대기 시간(초). 앱 xhr timeout과 같은 값
    let apiDetailPath = this.apiPrefix + `/${siteId}/devices/${bridgeId}/proxy?timeout=${timeout}`
    let bridgeApiPath = `ckbapiv2/streamer/download?url=${rtspUrl}&stime=${startTime}&etime=${endTime}` // e.g 2024-09-10T12:52:22Z
    let data = {
      headers: {
        method: 'get',
        path: bridgeApiPath,
        mqttResponseTopic: `devices/${siteId}/${bridgeId}/0/ckbapiv2/res/` + Math.floor(Math.random() * 1000000000000)
      }
    }
    return Vue.http.put(Vue.env.apiPath + apiDetailPath, data, Vue.auth.getBearerHeader(PLAYBACK_API_TIMEOUT_MS))
  },
}